import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-button-edit-view-delete-renderer',
  template: `
  <style>
  .row-action-btns {
    min-width: 70px;
  }
  .row-action-btns .mat-icon-button:not(:last-child) {
    margin-right: 10px;
  }
  .row-action-btns .mat-icon-button.edit-btn {
      background: #3aafe4;
  }
  .row-action-btns .mat-icon-button {
      width: 30px;
      height: 30px;
      line-height: 30px;
      border-radius: 10px;
      visibility: visible;
      transition: all .4s;
      top:5px
  }
  .mat-button-wrapper{
    padding: 0;
  }
  </style>
    <div class="row-action-btns">
       <button
        (click)="onClick($event, 'view')"
        mat-mini-fab
        matTooltip="View approvers"
        aria-label="View"
        class="mat-focus-indicator mat-mini-fab mat-button-base mat-primary"
        style="background-color: orange;">
        <span><i class="fa fa-eye" style="color: #fff;"></i></span>
        <span matripple class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
        <span class="mat-button-focus-overlay"></span>
      </button>
      <button
        (click)="onClick($event, 'edit')"
        mat-mini-fab
        matTooltip="Edit record"
        aria-label="Edit"
        class="mat-focus-indicator mat-mini-fab mat-button-base mat-primary"
        style="background-color: blue;margin-left: 5px;">
        <span><i class="fa fa-pencil" style="color: #fff;"></i></span>
        <span matripple class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
        <span class="mat-button-focus-overlay"></span>
      </button>
      <button
        (click)="onClick($event, 'delete')"
        mat-mini-fab
        matTooltip="Delete record"
        aria-label="Delete"
        class="mat-focus-indicator mat-mini-fab mat-button-base mat-primary"
        style="background-color: red; margin-left: 5px;">
        <span><i class="fa fa-trash" style="color: #ffffffff;"></i></span>
        <span matripple class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
        <span class="mat-button-focus-overlay"></span>
      </button>
    </div>
  `
})
export class ButtonEditViewDeleteRendererComponent implements ICellRendererAngularComp {

  params: any;
  label!: string;

  agInit(params: any): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event: any, action: string) {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        action: action,
        rowData: this.params.node.data
      };
      this.params.onClick(params);
    }
  }
}
